import { render, staticRenderFns } from "./Document-notification-search.vue?vue&type=template&id=b84008f0&scoped=true"
import script from "./Document-notification-search.vue?vue&type=script&lang=js"
export * from "./Document-notification-search.vue?vue&type=script&lang=js"
import style0 from "./Document-notification-search.vue?vue&type=style&index=0&id=b84008f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84008f0",
  null
  
)

export default component.exports